export default __webpack_public_path__ + "static/media/7.7100d73a.jpg";